<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
 
      <div class="条件区">
        <app-wmsm-conditions [show]="true"  [QueryFromParent]="onQueryClick()" (listenForm)="getFormValue($event)" [ShowPRNO]="false"></app-wmsm-conditions>
      </div>
      <nz-card >

    <div >
      <strong class="margin-left-8 result">{{ "Results" | translate}}({{nzTotal}})</strong>
    </div>
    <div class="表格" style="margin-top: 10px;">
      <nz-table #colSpanTable [nzData]="listOfData"   style="margin-bottom: 10px"  nzSize="middle" nzShowSizeChanger
        [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize' [nzPageIndex]='pageIndex' [nzScroll]="{ y: '800px',x:'3600px' }" >
        <thead>
          <tr>
            <th scope="col" style="color:rgb(12, 16, 223);font-weight: bold;" nzWidth="120px">{{ "VendorConfirDate" | translate}}</th>
            <th scope="col" style="color:rgb(12, 16, 223);font-weight: bold;" nzWidth="120px">{{ "UserRequiDate" | translate}}</th>

            <th scope="col" style="color:rgb(12, 16, 223);font-weight: bold;" nzWidth="150px">{{ "Reason" | translate}}</th>
            <th scope="col" style="color:rgb(12, 16, 223);font-weight: bold;" nzWidth="200px" >{{ "Remark" | translate}}</th>
            <th scope="col" style="color:rgb(12, 16, 223);font-weight: bold;" nzWidth="90px">{{ "ShipmentDate" | translate}}</th>
            <th scope="col" style="color:rgb(12, 16, 223);font-weight: bold;" nzWidth="90px">{{ "ShipmentFile" | translate}}</th>
            <th scope="col" style="color:rgb(12, 16, 223);font-weight: bold;" nzWidth="90px">{{ "ActualDateArrival" | translate}}</th>
            <th scope="col" style="color:rgb(12, 16, 223);font-weight: bold;" nzWidth="90px">{{ "DeliveryDate" | translate}}</th>
            <th scope="col" nzWidth="80px">{{ "table.Company" | translate}}</th>
            <th scope="col" nzWidth="120px">{{ "table.VendorCode" | translate}}</th>
            <th scope="col" nzWidth="200px">{{ "table.VendorName" | translate}}</th>
            <th scope="col" nzWidth="150px" *ngIf="Userlimits" >{{ "table.PRNO" | translate}}</th>
            <th scope="col" *ngIf="Userlimits" >{{ "table.PRLN" | translate}}</th>
            <th scope="col" nzWidth="150px" [nzSortFn]="true" (nzSortOrderChange)="sortChange($event)">{{ "table.PONO" | translate}}</th>
            <th scope="col" nzWidth="50px">{{ "table.POLN" | translate}}</th>
            <th scope="col" nzWidth="100px" >{{ "table.DeliverDate" | translate}}</th>
            <th scope="col" nzWidth="120px">{{ "IsAcceptance" | translate}}</th>
            <th scope="col" nzWidth="400px" style="text-align: center;">{{ "table.Spec" | translate}}</th>
            <th scope="col" nzWidth="400px" style="text-align: center">{{ "SpecDescription" | translate}}</th>
            <th scope="col" nzWidth="80px">{{ "table.OrderQty" | translate}}</th>
            <th scope="col" nzWidth="80px">{{ "table.BackLogQty" | translate}}</th>
            <th scope="col" nzWidth="60px">{{ "table.Unit" | translate}}</th>
            <th scope="col" nzWidth="50px" *ngIf="!Userlimits">{{ "table.TaxRate" | translate}}</th>
            <th scope="col" nzWidth="120px">{{ "table.IMPN" | translate}}</th>
            <th scope="col" nzWidth="80px">{{ "table.Buyer" | translate}}</th>
            <th scope="col"  *ngIf="!Userlimits" nzWidth="130px">{{ "table.AppID" | translate}}</th>
            <th scope="col" nzWidth="50px" [nzRight]="fixedColumn">{{ "act" | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of colSpanTable.data;let i=index">

            <td >{{data.vDate || ''}}</td>
            <td >{{data.uDate || ''}}</td>
            <td *ngIf="tw">{{data.unreason || ''}}</td>
            <td *ngIf="cn">{{data.unChreason || ''}}</td>
            <td *ngIf="en">{{data.unEnreason || ''}}</td>
            <td *ngIf="vn">{{data.unEnreason || ''}}</td>
            <td >{{data.vendorRemark || ''}}</td>
            <td>{{data.vDeliveryDate | date:'yyyy-MM-dd' }}</td>
            <td style="text-align:center;">
              <span class="linkLabel" style="text-decoration:underline;color:blue" *ngIf="data.vDispatchFileName == null">
                <a (click)="downloadFile(data.vDispatchFile,data.vDispatchFileName)">{{data.vDispatchFileName}}</a>
              </span>
              <span class="linkLabel" style="text-decoration:underline;color:blue" style="font-size: 20px;cursor: pointer;" nz-icon nzType="file" nzTheme="twotone" nz-tooltip nzTooltipTitle="{{data.vDispatchFileName}}"
               *ngIf="data.vDispatchFileName != null" (click)="downloadFile(data.vDispatchFile,data.vDispatchFileName)">
              </span>

          </td>
            <td>{{data.vAcDate | date:'yyyy-MM-dd'}}</td>
            <td style="text-align:center;"> 
              <span class="linkLabel" style="text-decoration:underline;color:blue" *ngIf="data.vDeliverGoodsFileName == null">
                <a (click)="downloadFile(data.vDeliverGoodsFile,data.vDeliverGoodsFileName)">{{data.vDeliverGoodsFileName}}</a>
              </span>

              <span class="linkLabel" style="text-decoration:underline;color:blue" style="font-size: 20px;cursor: pointer;" nz-icon nzType="file" nzTheme="twotone" nz-tooltip nzTooltipTitle="{{data.vDeliverGoodsFileName}}"
              *ngIf="data.vDeliverGoodsFileName != null" (click)="downloadFile(data.vDeliverGoodsFile,data.vDeliverGoodsFileName)">
             </span>

          </td>
            <td >{{data.companyCode || ''}}</td>
            <td >{{data.vendorCode || ''}}</td>
            <td >{{data.vendorName || ''}}</td>
            <td *ngIf="Userlimits"  >{{data.prno}}</td>
            <td *ngIf="Userlimits" >{{data.prln}}</td>
            <td >{{data.pono || ''}}</td>
            <td >{{data.poln || ''}}</td>
            <td >{{data.deliveryDate || ''}}</td>
                        <td>{{data.isAcceptance == null || data.isAcceptance === '' ? 'N' : data.isAcceptance}}</td>

            <td >{{data.spec || ''}}</td>
            <td>{{data.specdec || ''}}</td>
            <td >{{data.orderQty || ''}}</td>
            <td >{{data.baklogQty || ''}}</td>
            <td >{{data.unit || ''}}</td>
            <td *ngIf="!Userlimits">{{data.taxRate}}</td>
            <td >{{data.impn || ''}}</td>
            <td >{{data.buyerName || ''}}</td>
            <td  *ngIf="!Userlimits">{{data.prApplicant || ''}}</td>
            <td [nzRight]="fixedColumn" style="text-align: center;"><span nz-icon nzType="edit" nzTheme="twotone" (click)="onEdit(data)"  style="font-size: 20px; cursor: pointer;"></span></td>
            <!-- <td [nzRight]="fixedColumn"><img src="../../../assets/image/img_edit.png" [alt]="'Button.Update'|translate" (click)="onEdit(data)" class="pointer"></td> -->
          </tr>
        </tbody>
      </nz-table>
      <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'" nzShowSizeChanger
      [nzPageSize]='pageSize' (nzPageSizeChange)="nzPageSizeChange($event)" [nzPageSizeOptions]="[10, 20, 50,100]"
     (nzPageIndexChange)="nzPageIndexChange($event)" [nzItemRender]="renderItemTemplate"></nz-pagination>
     
     <ng-template #renderItemTemplate let-type let-page="page">
 
       <a *ngIf="type === 'page'">{{ page }}</a>
       <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
       <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
     </ng-template>
    
  
    </div>
    <div class="按钮区">
      <div nz-row nzGutter="64">
        <!-- <div nz-col>
          <button nz-button nzType="primary" class="default-button" (click)="exportTableToExecl()">{{'DownloadExcel'|translate}}</button>
        </div> -->
        <!-- <div nz-col>
          <nz-upload  [nzFileList]="fileList" [nzBeforeUpload]="beforeUpload" >
            <button nz-button class="upload-button default-button" >
                <em nz-icon nzType="upload"></em>{{'UploadExcel'|translate}}
            </button>
        </nz-upload>
        </div> -->
      </div>
    </div>
  </nz-card >

      <!-- 修改 -->
      <app-edit-wmsm001 *ngIf="isEdit" [isEdit]="true" [editData]="editData" (close)="closeEdit()"
          (save)="saveEdit($event)"></app-edit-wmsm001>

  </div>

  </nz-spin>
  